import {Vue} from 'ui.vue';

export let Registration = {
	name: 'Registration',
	mixins: [BX.Citrus.Vue.Component.FormMixin],
	computed: {
		loc() {
			return Vue.getFilteredPhrases("TPL_REGISTER_");
		},
	},
	data() {
		return {
			needScrollToError: true,
			confirmStep: false,
			userId: 0,
			componentName: "",
			action: "",
		}
	},
	methods: {
		/**
		 * Не сбрасываем данные в текущей форме пользователя
		 */
		resetFields() {

		},
		/*prepareData(formData, fields = this.formFields) {
			BX.Citrus.Vue.Component.FormMixin.methods.prepareData.call(this, formData, fields);
		},*/
		onResponse(response) {
			this.loading = false;

			let message = response && response.hasOwnProperty('message') && response.message ? response.message : false;
			if (response && response.hasOwnProperty('success') && response.success) {
				if (message)
					this.message = message;
			} else {
				this.onError(message || this.loc.TPL_REGISTER_UNKNOWN_ERROR_MESSAGE)
			}

			if (response.hasOwnProperty("user_id") && response.user_id > 0) {
				this.userId = response.user_id;
				this.confirmStep = true;
			}
		},
		onError(message) {
			this.error = true;
			this.message = message;
			this.loading = false;

			if (!this.$dialog) {
				alert(this.message);

				return;
			}

			this.$dialog
				.alert({
					title: this.message,
					body: "",
					pretitle: '<svg width="63" height="62" viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
						'\t\t\t\t\t\t\t\t<path fill-rule="evenodd" clip-rule="evenodd" d="M31.4999 61.7335C39.646 61.7335 47.4584 58.4975 53.2185 52.7373C58.9787 46.9772 62.2147 39.1648 62.2147 31.0187C62.2147 22.8727 58.9787 15.0602 53.2185 9.3001C47.4584 3.53997 39.646 0.303955 31.4999 0.303955C23.3539 0.303955 15.5414 3.53997 9.7813 9.3001C4.02117 15.0602 0.785156 22.8727 0.785156 31.0187C0.785156 39.1648 4.02117 46.9772 9.7813 52.7373C15.5414 58.4975 23.3539 61.7335 31.4999 61.7335ZM41.8946 41.6253C40.5277 42.9921 38.3117 42.9921 36.9448 41.6253L31.5002 36.1807L26.0555 41.6254C24.6886 42.9922 22.4726 42.9922 21.1057 41.6254C19.7389 40.2585 19.7389 38.0424 21.1057 36.6756L26.5504 31.2309L20.6814 25.3618C19.3145 23.995 19.3145 21.7789 20.6814 20.4121C22.0482 19.0453 24.2643 19.0453 25.6311 20.4121L31.5002 26.2812L37.3692 20.4122C38.736 19.0453 40.9521 19.0453 42.3189 20.4122C43.6858 21.779 43.6858 23.9951 42.3189 25.3619L36.4499 31.2309L41.8946 36.6755C43.2614 38.0424 43.2614 40.2585 41.8946 41.6253Z" fill="#EB5757"></path>\n' +
						'\t\t\t\t\t\t\t</svg>'
				}, {
					html: true,
					okText: this.locMixin.CITRUS_FORM_MIXIN_CLOSE
				});
		},
		resetAll() {
			this.userId = 0;
			this.confirmStep = false;
			this.restartForm();
			BX.Citrus.Vue.Component.FormMixin.methods.resetFields.call(this);
		},
		onConfirmedSuccess: function (response) {
			this.success = true;
			this.message = this.loc.TPL_REGISTER_REGISTER_SUCCESS;

			if (!this.$dialog) {
				alert(this.message);
				this.redirect(response.backurl);

				return;
			}

			this.$dialog
				.alert({
					title: this.message,
					pretitle: '<div class="m-auto h-28 mb-6">' + this.icons.success + '</div>'
				}, {
					html: true,
					okText: this.loc.TPL_REGISTER_REGISTER_SUCCESS_BTN
				})
				.then(() => {
					this.redirect(response.backurl);
				});
		},
		redirect(backurl) {
			window.location.href = backurl;
		},
		registerAgainRequest() {
			if (this.loading)
				return;

			this.loading = true;
			this.error = false;
			this.success = false;
			this.message = '';

			BX.ajax.runComponentAction('citrus:system.auth.actions', 'registerAgain', {
					mode: 'class',
				})
				.then((response) => {
					let message = response.data && response.data.hasOwnProperty('message') && response.data.message ? response.data.message : false;
					if (response && response.data && response.data.hasOwnProperty('success') && response.data.success) {
						if (message)
							this.message = message;
					} else {
						this.error = true;
						this.message = message ? message : this.loc.TPL_REGISTER_UNKNOWN_ERROR_MESSAGE;
					}

					if (response.data.hasOwnProperty("backurl")) {
						this.redirect(response.data.backurl);
					}

					this.loading = false;
				}).catch((response) => {
				this.message = response && response.errors && response.errors.length > 0 ? response.errors[0].message : this.loc.TPL_REGISTER_UNKNOWN_ERROR_MESSAGE;
				this.error = true;
				this.loading = false;
			});
		},
	},
};

export default {Registration};
